import { Button, type ButtonProps } from "@/components/ui/button";
import type { InfoModalDescriptor } from "@/services/simple-modal/simple-modal-types";

export interface InfoSimpleModalProps {
    modal: InfoModalDescriptor;
    onAcknowledge: () => void;
}

const acknowledgeButtonVariant = (tone: InfoModalDescriptor["tone"]): ButtonProps["variant"] => {
    if (tone === "danger") {
        return "destructive";
    }
    if (tone === "info") {
        return "info";
    }
    if (tone === "success") {
        // No "success" button variant exists; "secondary" is the closest neutral-positive style.
        return "secondary";
    }
    if (tone === "warning") {
        return "outline";
    }
    return "default";
};

export function InfoSimpleModal({ modal, onAcknowledge }: InfoSimpleModalProps) {
    return (
        <>
            {modal.body ? <div>{modal.body}</div> : null}
            <div className={"flex justify-end gap-2 max-sm:flex-col max-sm:gap-4"}>
                <Button
                    size={"lg"}
                    onClick={onAcknowledge}
                    type={"button"}
                    variant={acknowledgeButtonVariant(modal.tone)}
                >
                    {modal.closeLabel}
                </Button>
            </div>
        </>
    );
}
